A<template>
  <div class="baseBody relative">
    <div class="dateWeek">
      <DynamicDate></DynamicDate>
    </div>
    <div class="topHead flex justify-between">
      <div class="leftHead"></div>
      <div class="midHead">大数据看板数据汇总</div>
      <div class="rightHead"></div>
    </div>
    <div id="main"></div>
  </div>
</template>

<script>
import DynamicDate from "../../components/dynamicDate/index.vue";
import china from "echarts/map/json/china";

export default {
  components: {
    DynamicDate,
  },
  data() {
    return {
      showData: [{
        "name": "安徽省",
        "value": [3, 2],
        "coords": [
          [117.29, 31.86],
          [121.29, 38.86]
        ]
      }, {
        "name": "贵州省",
        "value": [135, 3],
        "coords": [
          [106.71, 26.6],
          [110.71, 33.6]
        ]
      }],
      showData2: [{
        "name": "贵州省",
        "value": [135, 3],
        "coords": [
          [106.71, 26.6],
          [110.71, 33.6]
        ]
      }],
      showData1: [{
        "name": "安徽省",
        "value": [117.29, 31.86]
      }]
    }
  },
  mounted() {

    this.initMap()
  },
  methods: {
    initMap() {
      let myChart = this.$echarts.init(document.getElementById("main"));
      // 注册的是中国地图，必须包括geo组件或者mep图标类型的时候才可以使用
      // 地图：世界地图，中国地图，省份地图，市区地图
      this.$echarts.registerMap("china", china);
      myChart.setOption({
        // 背景色
        // backgroundColor: "rgb(121,145,200)",
        // 配置项(组件)
        geo: {
          map: "china",
          // 地图的长宽比例
          aspectScale: 0.75,
          // 图层
          zoom: 1.1,
          // 样式
          itemStyle: {
            normal: {
              borderColor: "#80c4dc",
              borderWidth: 5,
              areaColor: 'rgba(7,34,124,0.8)',
              fontWeightL: 700,
              shadowColor: 'rgba(19, 59,165, 1)',
              shadowOffsetX: -2,
              shadowOffsetY: 2,
              shadowBlur: 10
            },
            emphasis: {
              areaColor: '#389BB7',
              borderWidth: 0
            },
          },

          region: [{
            name: "南海诸岛",
            itemStyle: {
              opacity: 0,
            },
          }, ],
        },
        series: [
          // 配置地图相关的数据参数
          {
            type: "map",
            label: {
              normal: {
                // 显示文字
                show: true,
                textStyle: {
                  color: "#1DE9B6",
                },
              },
              emphasis: {
                textStyle: {
                  color: "rgb(183,185,14)",
                },
              },
            },
            data: this.showData,
            // 图层
            zoom: 1.1,
            map: "china",
            itemStyle: {
              normal: {
                // areaColor: 'rgba(5,41,134,0.9)',
                areaColor:{colorStops: [{
                    offset: 0,
                    color: "rgb(5,108,236)"
                  },
                    {
                      offset: 1,
                      color: "rgb(5,41,134)"
                    },
                  ],
                },
                borderColor: '#fff',
                fontWeightL: 700,
                borderWidth: 1,
              },
              // 高亮效果
              emphasis: {
                areaColor: "rgb(46,229,206)",
                borderWidth: 0.1,
              },
            },
          },
          // 区域散点图
          {
            type: 'effectScatter',
            coordinateSystem: 'geo',
            zlevel: 2,
            symbolSize: 10,
            rippleEffect: { //坐标点动画
              period: 3,
              scale: 5,
              brushType: 'fill'
            },
            label: {
              normal: {
                show: true,
                position: 'right',
                formatter: '{b}',
                color: '#b3e2f2',
                fontWeight: 'bold',
                fontSize: 16
              }
            },
            data: this.showData1,
            itemStyle: { //坐标点颜色
              normal: {
                show: true,
                color: '#ff8003',
                shadowBlur: 20,
                shadowColor: '#fff'
              },
              emphasis: {
                areaColor: '#f00'
              }
            }
          }
        ],
      });
    }
  }
}
</script>

<style>
.mapTcStyle{background:none!important;box-sizing: border-box;border-radius: 20px;}
.tcNeiTitle{font-size:22px;height:50px;padding-top:30px;font-weight: bold;color:#69f5ff;}
.tcNeiBox .leftImage{width:500px;height:360px;padding:10px;box-sizing: border-box;box-shadow:0 0 20px inset #2281c4;;}

.textInfo{height:360px;width:180px;font-size:16px;color:#FFFFFF;line-height:1.9;overflow-y: auto;padding-right:10px;box-sizing: border-box;}
#main {
  width: 100%;
  height: calc(100vh - 105px);
  position: relative;
}

#main::before {
  position: absolute;
  content: '';
  width: 100%;
  height: 100%;
  background: url('../../assets/images/allBg.png') 20px 150px no-repeat;
  background-size: 100% 100%;
  bottom: 0;
  left: 0;
  opacity: 0.5;
}

.leftMessageBox {
  position: absolute;
  left: 20px;
  z-index: 999;
  bottom: 50px;
  width: 360px;
  height: 185px;
  background: url('../../assets/images/leftBox.png') center no-repeat;
  background-size: 100% 100%;
  padding: 22px 31px;
}

.circle {
  width: 780px;
  height: 780px;
  position: absolute;
  left: -30%;
  top: calc(50% - 390px);
  opacity: 0.5;
  transform: scale(0.7);
  -o-transform: rotate(0.7);
  -webkit-transform: rotate(0.7);
  -moz-transform: rotate(0.7);

}

.circle1 {
  width: 780px;
  height: 780px;
  background: url('../../assets/images/circle1.png')center no-repeat;
  background-size: 100% 100%;
  position: absolute;
  animation: myfirst 15s infinite linear;
  -webkit-animation: myfirst 15s infinite linear;
  /* Safari and Chrome */
}

.circle2 {
  width: 780px;
  height: 780px;
  background: url('../../assets/images/circle2.png')center no-repeat;
  background-size: 100% 100%;
  left: 0;
  top: 0;
  position: absolute;
  animation: myfirst2 15s infinite linear;
  -webkit-animation: myfirst2 15s infinite linear;
  /* Safari and Chrome */
}

.circle3 {
  width: 780px;
  height: 780px;
  background: url('../../assets/images/circle3.png')center no-repeat;
  background-size: 100% 100%;
  left: 0;
  top: 0;
  position: absolute;
  animation: myfirst 15s infinite linear;
  -webkit-animation: myfirst 15s infinite linear;
  /* Safari and Chrome */
}

.circle4 {
  width: 780px;
  height: 780px;
  background: url('../../assets/images/circle4.png')center no-repeat;
  background-size: 100% 100%;
  left: 0;
  top: 0;
  position: absolute;
  animation: myfirst2 15s infinite linear;
  -webkit-animation: myfirst2 15s infinite linear;
  /* Safari and Chrome */
}

.dateWeek {
  position: absolute;
  top: 0;
  left: 0;
  width: 200px;
  height: 50px;
  color: #ffffff;
}

.leftMessageBox .neiBox {
  box-shadow: 0 0 50px inset rgba(0, 151, 255, 1);
  height: 140px;
  border-radius: 20px;
  padding: 17px;
  box-sizing: border-box;
}

.baseBody {
  width: 100%;
  height: 100vh;
  background: #000208 url('../../assets/images/bg1.png') center no-repeat;
  background-size: 100% 100%;
  overflow: hidden;
}

.zwRightBox {
  width: 340px;
  height: calc(100vh - 0);
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  border-radius: 260px 0 0 160px/350px 0 0 300px;
  background: url('../../assets/images/leftBoxbg.png') center no-repeat;
;
  background-size: 100% 100%;
  /* background: -webkit-linear-gradient(left, rgba(0,151,255,0.3) ,  rgba(0,151,255,0.03)); /* Safari 5.1 - 6.0 */
  /*  background: -o-linear-gradient(right, rgba(0,151,255,0.3) ,  rgba(0,151,255,0.03)); /* Opera 11.1 - 12.0 */
  /*  background: -moz-linear-gradient(right, rgba(0,151,255,0.3) ,  rgba(0,151,255,0.03)); /* Firefox 3.6 - 15 */
  /* background: linear-gradient(to right,rgba(0,151,255,0.3) ,  rgba(0,151,255,0.03)); /* 标准的语法 */
}

.zwRightBoxLine {
  width: 2px;
  height: 200px;
}

.zwRightMneuItem {
  background: url('../../assets/images/btnNormal.png') center no-repeat;
  background-size: 100% 100%;
  width: 230px;
  height: 62px;
  line-height: 62px;
  cursor: pointer;
  transition: transform 0.5s;
  -webkit-transition: transform 0.5s;
  transform: scale(1);
  -webkit-transform: scale(1);
  /*兼容-webkit-引擎浏览器*/
  -moz-transform: scale(1);
}

.zwRightMneuItem:hover {
  background: url('../../assets/images/btnNormalChecked.png') center no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
  transition: transform 0.5s;
  -webkit-transition: transform 0.5s;
  transform: scale(1.1);
  -webkit-transform: scale(1.1);
  /*兼容-webkit-引擎浏览器*/
  -moz-transform: scale(1.1);
}

.topHead {
  width: 100%;
  height: 103px;
}

.topHead .leftHead {
  width: 28%;
  height: 81px;
  background: url('../../assets/images/leftTop.png') center no-repeat;
  background-size: 100% 100%;
}

.topHead .midHead {
  width: 44%;
  height: 103px;
  background: url('../../assets/images/midTop.png') center no-repeat;
  background-size: 100% 100%;
  text-align: center;
  font-weight: bold;
  font-size: 38px;
  line-height: 93px;
  color: #FFFFFF;
}

.topHead .rightHead {
  width: 28%;
  height: 81px;
  background: url('../../assets/images/rightTop.png') center no-repeat;
  background-size: 100% 100%;
}
</style>

